export default "__VITE_ASSET__bb6551b3__"